// extracted by css-extract-rspack-plugin
export default {"category-toggle":"lX7nDCGL","category-toggle__pill":"CVVs3SNf","category-toggle__pill--active":"BmiJYRwc"};